export default __webpack_public_path__ + "static/po-system2-683ffdd00c6fa95000cd18a5ddf525bc.png";